import apiClient from '../apiClient';
import { POST_TOUR_TRANSACTION_CONFIRMATION_URL } from '../apiUrl';

const postTourTransactionConfirmationApi = data => {
  return apiClient.post(POST_TOUR_TRANSACTION_CONFIRMATION_URL, data);
};

export default postTourTransactionConfirmationApi;
